import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import vuetify from './plugins/vuetify';

import wysiwyg from "vue-wysiwyg"; // text editor
// message
import Toasted from 'vue-toasted';
let messageOptions = {
	position: 'top-center',
	duration: 3500,
	keepOnHover: true,
	type: 'success',
	containerClass: 'custom-toast-message-section',
	className: 'custom-toast-message',
}
Vue.use(Toasted, messageOptions)

axios.defaults.baseURL = process.env.VUE_APP_API_BASE

Vue.config.productionTip = false

Vue.use(wysiwyg, {})

// globals
Vue.prototype.$defaultImg = process.env.VUE_APP_FILE_BASE+'default-avatar.png'

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
